import { Position } from "@blueprintjs/core"
import { DatePicker, TimePrecision } from "@blueprintjs/datetime"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import React from "react"
import CustomButton from "../../Atoms/CustomButton"
import CustomPopoverAbsolute from "../../Atoms/CustomPopoverAbsolute"
import { withFormController } from "../../Molecules/FormController"
dayjs.extend(advancedFormat)

const CustomTimePicker = ({ onChange, path, value, absolute, time, fill }) => {
  const parsedValue = value
    ? value instanceof Date
      ? value
      : new Date(value)
    : undefined

  function handleChange(date) {
    onChange(path, date?.toISOString())
  }

  return (
    <>
      <CustomPopoverAbsolute
        absolute={absolute}
        minimal
        position={Position.BOTTOM_LEFT}
        content={
          <DatePicker
            value={parsedValue}
            path={path}
            onChange={handleChange}
            showActionsBar={true}
            timePickerProps={
              time
                ? {
                    useAmPm: true,
                    showArrowButtons: true,
                    precision: TimePrecision.SECOND,
                  }
                : undefined
            }
          />
        }
      >
        <CustomButton
          fill={fill}
          icon="calendar"
          text={
            parsedValue
              ? dayjs(parsedValue).format(
                  time ? "Do MMMM YYYY, h:mm a" : "Do MMMM YYYY"
                )
              : "No Date!"
          }
        />
      </CustomPopoverAbsolute>
    </>
  )
}

export default withFormController(CustomTimePicker)
